"use strict";
/**
 * @packageDocumentation
 * @module Logger.Builders
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerSettingBuilder = void 0;
var LoggerSettingBuilder = /** @class */ (function () {
    function LoggerSettingBuilder() {
        this.uppercase = false;
        this.underline = false;
        this.bold = false;
        this.italic = false;
        this.prefix = "";
        this.suffix = "";
        this.disabled = false;
    }
    LoggerSettingBuilder.initial = function () {
        return new LoggerSettingBuilder();
    };
    LoggerSettingBuilder.disabled = function () {
        return LoggerSettingBuilder.initial().withDisabled();
    };
    LoggerSettingBuilder.prototype.withUpperCase = function (toggle) {
        if (toggle === void 0) { toggle = true; }
        this.uppercase = toggle;
        return this;
    };
    LoggerSettingBuilder.prototype.withUnderline = function (toggle) {
        if (toggle === void 0) { toggle = true; }
        this.underline = toggle;
        return this;
    };
    LoggerSettingBuilder.prototype.withBold = function (toggle) {
        if (toggle === void 0) { toggle = true; }
        this.bold = toggle;
        return this;
    };
    LoggerSettingBuilder.prototype.withItalic = function (toggle) {
        if (toggle === void 0) { toggle = true; }
        this.italic = toggle;
        return this;
    };
    LoggerSettingBuilder.prototype.withPrefix = function (prefix) {
        this.prefix = prefix;
        return this;
    };
    LoggerSettingBuilder.prototype.withSuffix = function (suffix) {
        this.suffix = suffix;
        return this;
    };
    LoggerSettingBuilder.prototype.withEnabled = function () {
        this.disabled = false;
        return this;
    };
    LoggerSettingBuilder.prototype.withDisabled = function () {
        this.disabled = true;
        return this;
    };
    LoggerSettingBuilder.prototype.get = function () {
        if (this.disabled)
            return false;
        return {
            uppercase: this.uppercase,
            underline: this.underline,
            bold: this.bold,
            italic: this.italic,
            prefix: this.prefix,
            suffix: this.suffix,
        };
    };
    return LoggerSettingBuilder;
}());
exports.LoggerSettingBuilder = LoggerSettingBuilder;
//# sourceMappingURL=LoggerSettingBuilder.js.map